/**
 * CareSessionStatusService
 * Service for managing care session statuses
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for care session status CRUD operations
 */
export class CareSessionStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? CareSessionStatusService.DEFAULT_SERVICE_PATH,
            basePath: CareSessionStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
CareSessionStatusService.DEFAULT_SERVICE_PATH = 'ac-counselling';
CareSessionStatusService.BASE_PATH = 'api/care-session-statuses';
//# sourceMappingURL=CareSessionStatusService.js.map